import React from 'react';
import './Services.css';
import { wrap } from 'framer-motion';

export default function Services() {
  return (
    <div className="services">
      <h2>Our Services</h2>

      
    </div>
  );
}
